var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAskTaraTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 154,
    viewBox: "0 0 285 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -64.6944,
    y: -81.9461,
    width: 709.482,
    height: 282.499
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(53.91px)",
      clipPath: "url(#bgblur_0_606_2603_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_606_2603)",
    "data-figma-bg-blur-radius": 107.824
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.1296,
    y: 25.8779,
    width: 493.834,
    height: 66.8509,
    rx: 33.4254,
    fill: "url(#paint0_linear_606_2603)",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_606_2603)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_606_2603)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.5549,
    cy: 59.3035,
    r: 16.1736,
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.5549,
    cy: 59.3035,
    r: 15.5911,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.16497
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71,
    filter: "url(#filter2_i_606_2603)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.5553,
    cy: 67.9297,
    r: 18.3301,
    fill: "#FFDD33"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_606_2603)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.555,
    cy: 70.0862,
    r: 11.8606,
    fill: "#FFDD33"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M103.973 67.3037L109.772 51.0551H112.204V53.9828H111.348L107.013 67.3037H103.973ZM106.9 63.1036L107.677 60.8628H115.12L115.886 63.1036H106.9ZM115.785 67.3037L111.449 53.9828V51.0551H113.037L118.825 67.3037H115.785ZM125.142 67.5402C124.106 67.5402 123.216 67.39 122.473 67.0898C121.73 66.782 121.145 66.3541 120.717 65.8061C120.296 65.2581 120.041 64.62 119.951 63.8918V63.813H122.71L122.721 63.9031C122.849 64.3835 123.111 64.7664 123.509 65.0516C123.915 65.3369 124.466 65.4795 125.164 65.4795C125.63 65.4795 126.028 65.4195 126.358 65.2994C126.696 65.1718 126.955 64.9991 127.135 64.7814C127.315 64.5637 127.405 64.3047 127.405 64.0044V63.9932C127.405 63.6329 127.278 63.3401 127.022 63.1149C126.767 62.8897 126.321 62.702 125.682 62.5519L123.701 62.1127C122.935 61.9401 122.297 61.7036 121.786 61.4033C121.276 61.0955 120.893 60.7164 120.638 60.266C120.383 59.8156 120.255 59.2976 120.255 58.7121V58.7008C120.255 57.9577 120.458 57.3121 120.863 56.7641C121.268 56.2086 121.831 55.7769 122.552 55.4691C123.28 55.1613 124.125 55.0075 125.086 55.0075C126.077 55.0075 126.925 55.1689 127.63 55.4916C128.344 55.8069 128.895 56.2386 129.286 56.7866C129.684 57.3346 129.905 57.9501 129.95 58.6333V58.7234H127.338L127.326 58.6558C127.251 58.1979 127.022 57.8225 126.64 57.5298C126.257 57.2295 125.739 57.0794 125.086 57.0794C124.673 57.0794 124.309 57.1394 123.993 57.2595C123.686 57.3796 123.445 57.5523 123.273 57.7775C123.108 57.9952 123.025 58.2504 123.025 58.5432V58.5657C123.025 58.7909 123.081 58.9936 123.194 59.1738C123.314 59.3539 123.502 59.5116 123.757 59.6467C124.012 59.7818 124.35 59.8982 124.77 59.9958L126.763 60.4349C127.987 60.7127 128.869 61.1105 129.41 61.6285C129.958 62.1465 130.232 62.8446 130.232 63.7229V63.7342C130.232 64.4924 130.014 65.1605 129.579 65.7385C129.143 66.3091 128.543 66.752 127.777 67.0672C127.011 67.3825 126.133 67.5402 125.142 67.5402ZM132.45 67.3037V50.7961H135.254V67.3037H132.45ZM140.051 67.3037L136.008 61.8199L137.889 59.8719L143.327 67.3037H140.051ZM134.893 63.4752L134.86 60.2322H135.355L139.848 55.2439H143.08L137.585 61.1556L136.819 61.4709L134.893 63.4752ZM154.137 67.3037V53.4986H149.239V51.0551H161.941V53.4986H157.031V67.3037H154.137ZM164.79 67.5064C164.001 67.5064 163.303 67.3563 162.695 67.056C162.095 66.7482 161.625 66.3241 161.288 65.7836C160.95 65.2356 160.781 64.6012 160.781 63.8806V63.8581C160.781 63.1374 160.957 62.5218 161.31 62.0114C161.67 61.4934 162.192 61.088 162.875 60.7953C163.558 60.495 164.384 60.3148 165.353 60.2548L169.924 59.9845V61.8312L165.747 62.0902C165.033 62.1352 164.489 62.3004 164.114 62.5856C163.746 62.8709 163.562 63.2538 163.562 63.7342V63.7567C163.562 64.2597 163.75 64.6538 164.125 64.939C164.508 65.2243 165.011 65.3669 165.634 65.3669C166.182 65.3669 166.67 65.2581 167.098 65.0404C167.526 64.8152 167.864 64.5149 168.111 64.1396C168.367 63.7567 168.494 63.3288 168.494 62.8559V59.1738C168.494 58.5657 168.303 58.0928 167.92 57.755C167.537 57.4097 166.982 57.237 166.253 57.237C165.6 57.237 165.071 57.3684 164.666 57.6311C164.268 57.8938 164.013 58.2392 163.9 58.6671L163.889 58.7459H161.276L161.288 58.6333C161.355 57.9276 161.599 57.3046 162.019 56.7641C162.447 56.2161 163.029 55.7882 163.765 55.4804C164.5 55.1651 165.368 55.0075 166.366 55.0075C167.379 55.0075 168.254 55.1726 168.99 55.5029C169.725 55.8332 170.292 56.2986 170.69 56.8992C171.088 57.4997 171.287 58.2091 171.287 59.0274V67.3037H168.494V65.5133H168.393C168.16 65.9262 167.864 66.2828 167.503 66.5831C167.15 66.8758 166.741 67.1048 166.276 67.2699C165.818 67.4276 165.323 67.5064 164.79 67.5064ZM173.888 67.3037V55.2439H176.68V57.2483H176.782C176.977 56.5501 177.322 56.0059 177.818 55.6155C178.321 55.2176 178.936 55.0187 179.664 55.0187C179.852 55.0187 180.028 55.03 180.194 55.0525C180.366 55.075 180.513 55.105 180.633 55.1426V57.6649C180.483 57.6123 180.299 57.5748 180.081 57.5523C179.871 57.5223 179.646 57.5072 179.405 57.5072C178.85 57.5072 178.366 57.6198 177.953 57.8451C177.547 58.0628 177.232 58.3818 177.007 58.8022C176.789 59.2151 176.68 59.7143 176.68 60.2998V67.3037H173.888ZM185.576 67.5064C184.788 67.5064 184.09 67.3563 183.482 67.056C182.881 66.7482 182.412 66.3241 182.074 65.7836C181.736 65.2356 181.567 64.6012 181.567 63.8806V63.8581C181.567 63.1374 181.744 62.5218 182.097 62.0114C182.457 61.4934 182.979 61.088 183.662 60.7953C184.345 60.495 185.171 60.3148 186.139 60.2548L190.711 59.9845V61.8312L186.533 62.0902C185.82 62.1352 185.276 62.3004 184.9 62.5856C184.533 62.8709 184.349 63.2538 184.349 63.7342V63.7567C184.349 64.2597 184.536 64.6538 184.912 64.939C185.295 65.2243 185.797 65.3669 186.421 65.3669C186.969 65.3669 187.457 65.2581 187.884 65.0404C188.312 64.8152 188.65 64.5149 188.898 64.1396C189.153 63.7567 189.281 63.3288 189.281 62.8559V59.1738C189.281 58.5657 189.089 58.0928 188.706 57.755C188.324 57.4097 187.768 57.237 187.04 57.237C186.387 57.237 185.858 57.3684 185.452 57.6311C185.054 57.8938 184.799 58.2392 184.686 58.6671L184.675 58.7459H182.063L182.074 58.6333C182.142 57.9276 182.386 57.3046 182.806 56.7641C183.234 56.2161 183.816 55.7882 184.551 55.4804C185.287 55.1651 186.154 55.0075 187.152 55.0075C188.166 55.0075 189.04 55.1726 189.776 55.5029C190.512 55.8332 191.079 56.2986 191.476 56.8992C191.874 57.4997 192.073 58.2091 192.073 59.0274V67.3037H189.281V65.5133H189.179C188.947 65.9262 188.65 66.2828 188.29 66.5831C187.937 66.8758 187.528 67.1048 187.062 67.2699C186.604 67.4276 186.109 67.5064 185.576 67.5064Z",
    fill: "#667085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_606_2603",
    x: -64.6944,
    y: -81.9461,
    width: 709.482,
    height: 282.499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.2518
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.5648
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.333333 0 0 0 0 0.411765 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_606_2603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "BackgroundImageFix",
    in2: "effect1_dropShadow_606_2603",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_606_2603_clip_path",
    transform: "translate(64.6944 81.9461)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.1296,
    y: 25.8779,
    width: 493.834,
    height: 66.8509,
    rx: 33.4254
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_606_2603",
    x: 51.2163,
    y: 38.2778,
    width: 52.8338,
    height: 52.8342,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.07824,
    dy: 5.3912
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.12164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.714243 0 0 0 0 0.612403 0 0 0 0 0.103204 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_606_2603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_606_2603",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.31296
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2919
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.65098 0 0 0 0 0.105882 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_606_2603"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_606_2603",
    x: 58.2252,
    y: 49.5996,
    width: 36.6602,
    height: 36.6602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.66512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_606_2603"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_606_2603",
    x: 50.0304,
    y: 42.4833,
    width: 53.0494,
    height: 53.0498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.07824
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.33203
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.737255 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_606_2603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_606_2603",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.60685
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_606_2603"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_606_2603",
    x1: 290.046,
    y1: 59.3034,
    x2: 290.046,
    y2: 25.8779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_606_2603"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.3813,
    y: 43.1299,
    width: 32.3472,
    height: 32.3472,
    rx: 16.1736,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskTaraTag);
export default __webpack_public_path__ + "static/media/ask-tara-tag.1ec75c8ddb9a9e1e8f1ecc61825b74f0.svg";
export { ForwardRef as ReactComponent };